// fileDeletion.js
// What the Delete buttons (the file card, the review dialog's footer, the bulk
// delete) show before services/cleaningGestures.js's deleteFile is called.
//
// deleteFile is the authority: it re-reads the file and its batch in its
// transaction and refuses with these same sentences (Spec 5 section 1). The
// copies here only let a button be disabled with the reason the gesture would
// give, so the person is not offered a click that is bound to be refused.

// '' when the file may be deleted now, otherwise the reason it may not.
// `batch` is the file's batch document when the caller follows it (it carries the
// answer-submission reservation); without it that one check is left to the
// gesture.
export function fileDeleteBlock(file, batch = null) {
  if (file.status === 'Cleaning') {
    return 'Decode is still working on this file; nothing can be changed yet.';
  }
  if (file.batch_status === 'running' || batch?.status === 'running') {
    return 'This file is being checked against the table; nothing can be changed until that finishes.';
  }
  if (batch?.submitting) {
    return 'Answers are being submitted; wait until that finishes.';
  }
  // A failed deletion may be requested again ("Try again"); a live one may not.
  if (file.deletion && !file.deletion.failed) {
    return 'This file is already being deleted.';
  }
  return '';
}

// The confirmation shown before the request is written. Only a landed file has
// rows in the table to take with it, and answers given while it was checked stay
// on the other files they changed.
export function deleteConfirmationText(file, tableName) {
  if (file.batch_status === 'completed') {
    return `'${file.name}' will be removed, and the rows it added to ${tableName} with it. `
      + 'Answers given while it was checked stay on the other files they changed. '
      + 'You can always upload it again.';
  }
  return `'${file.name}' will be removed. You can always upload it again.`;
}
